import React, { useEffect, useState } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faTrash,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../common/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { UnitSizes } from "../../model/size.model";
import { SizesService } from "../../service/sizes.service";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";
import ApprovalTwoToneIcon from '@mui/icons-material/ApprovalTwoTone';
import BlockTwoToneIcon from '@mui/icons-material/BlockTwoTone';
import TimerTwoToneIcon from '@mui/icons-material/TimerTwoTone';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, MenuItem, TextField, ThemeProvider, Typography, createTheme, styled } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams } from '@mui/x-data-grid';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import { BrandsService } from "../../service/brands.service";


function ProductSizesTable() {

  const sizesSvc = new SizesService();
  const [selectedSize, setSelectedSize] = useState(1);
  //const [AvailableSizes, setAvailableSizes] = useState<UnitSizes[]>([]);
  const [selectedUnit, setSelectedUnit] = useState(0);
  const [availableUnits, setAvailableUnits] = useState<any[]>([]);
  const [selectedStatus, setSelectedStatus] = useState(99);
  const [sizesData, setSizesData] = useState<any[]>([]);

  const [selectedBrandId, setSelectedBrandId] = React.useState("select");
 const [availableBrands, setAvailableBrands] = useState([]);

  //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);

  const navigate = useNavigate();



  const toSizeDetails = (bIndex: string, action: string) => {                 
                        
    navigate('../sizedetails',{state:{                   
        sizeDetails : sizesData[Number(bIndex)-1],
        finishesData: sizesData ,
        selectedBrand : selectedBrandId,
        brandsData: availableBrands ,
        action : action
    }})
};
 
  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', flex: 1, },
    { field: 'size', headerName: 'Size', flex: 1, },
    {
      field: 'status', headerName: 'Status',flex: 1,
      renderCell: (params) => {


        return <div>
          {params.value == -1 && (<p style={{ color: "blue" }}>Unknown</p>)
            || params.value == 0 && (<p style={{ color: "red" }}>Disabled</p>)
            || params.value == 1 && (<p style={{ color: "green" }}>Active</p>)

          }
        </div>
      }

    },


    {
      field: "action",
      headerName: "Action",
      sortable: false,
      renderCell: (params) => {
        const onClick = (e: { stopPropagation: () => void; }) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellParams> = {};

          api
            .getAllColumns()
            .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
            .forEach(
              (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
            );
        };

        return <div>
          <Button onClick={(e) => toSizeDetails(params.value, "edit")} > <IconButton> <EditTwoToneIcon fontSize="small" /></IconButton></Button>

        </div>
      },
      flex: 1
    }

  ];
  //useEffect(() => {
 //, [selectedEnterprise, selectedStatus]);

  const loadProductSizesData = () => {

    sizesSvc.productsizes(selectedBrandId).then(data => {
      const res = data.data;
      //const { unit, sizes } = res.data;
      console.log("^^^^^^^^^^^^^^Unit " + res.length);
      // const unitGroups: any = [];
      /*  for (let index = 0; index < res.length; index++) {
          const unitG = res[index].unit;
          const sizesG = res[index].sizes;
          unitGroups.push({ ...sizesG, unit: unitG, });
        }*/
      console.log("grpp ", res);
      setAvailableUnits(res);

    });

  }


  useEffect(() => {

      console.log("eeee "+selectedBrandId)
  
      if (selectedBrandId == "select"){
        return;
      }
      loadProductSizesData();
      
    

  }, [selectedBrandId])



  let isLoadDataInit = false;
  useEffect(() => {

    if (!isLoadDataInit) {
      isLoadDataInit = true;
      //loadProductSizesData();
      loadBrandsData()
    }

  }, [])

  useEffect(() => {
    if (selectedUnit != 0) {
      console.log("Here ***************************")
      let cnt = 0;
      for (cnt = 0; cnt < availableUnits.length; cnt++) {
        console.log("size selected ", availableUnits[cnt]);
        if (selectedUnit == availableUnits[cnt].unit) {

          let cnt1 = 0;
          let unitselectd = selectedUnit;
          const peopleWithImages = availableUnits[cnt].sizes.map((person: any, index: any) => {
            cnt1 = cnt1 + 1;
            return {
              ...person,
              id: person.sizeId,
              unit: unitselectd,
              action: cnt1 // person.sizeId,
            };

          });
          setSizesData(peopleWithImages)
        }
      }
    }
  }, [selectedUnit])

 ///////////
 const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };


  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));
  
   interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
  }
  
  function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;
  
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
           
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }
  

 /////////
 
 const CustomFontTheme = createTheme({
  typography: {
    fontSize: 14
  }
});

const brandsService = new BrandsService();
const loadBrandsData = () => {

  brandsService.brands(1).then(data => {
    const res = data.data;
    //const { unit, sizes } = res.data;
    console.log("^^^^^^^^^^^^^^Unit " + res.length);
    // const unitGroups: any = [];
    /*  for (let index = 0; index < res.length; index++) {
        const unitG = res[index].unit;
        const sizesG = res[index].sizes;
        unitGroups.push({ ...sizesG, unit: unitG, });
      }*/
    console.log("grpp ", res);
    setAvailableBrands(res);

  });

}

  return (
    <div className="App border card">
      <div className="pt-3 col-md-12 row ">

      <div className=" mb-3 col-2   text-left ">
        <ThemeProvider theme={CustomFontTheme}>
          <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}  InputProps={{ sx: { height: 35 } }}
            className="form-control" name='brandId' defaultValue="select" value={selectedBrandId} 
            onChange={(e: any) => {
              setSelectedBrandId(e.target.value);
          
            }}
            >
            <MenuItem style={{fontSize:"small"}}  disabled value="select" key="select">Select</MenuItem>
            {availableBrands.map((_el: any) => <MenuItem style={{fontSize:"small"}} key={_el.brandId} value={_el.brandId}> {_el.brandName}</MenuItem>)}
          </TextField>
          </ThemeProvider>
        </div>
      



        <div className="col-3 form-group  text-left">
          <TextField select size="small" label="Size Unit" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
            className="form-control" name='brandId' defaultValue="select" value={selectedUnit} 
            onChange={(e: any) => {
              setSelectedUnit(e.target.value);
              }} >
            <MenuItem  style={{fontSize:"small"}}  disabled value={0} key={0}>Select</MenuItem>
            {availableUnits.map((_el: any) => <MenuItem  style={{fontSize:"small"}}  key={_el.unit} value={_el.unit}> {_el.unit}</MenuItem>)}
          </TextField>
        </div>
        <div className="col-6 form-group  text-right"></div>
        <div className="col-1 form-group  text-right p-0 ">
            <Button size="small" style={{ color: "green" }} className="form-control text-right" onClick={() =>
              // navigate('../sizedetails')
               {
                navigate('../sizedetails',{state:{
               
                  brandsData: availableBrands ,
                  selectedBrand : selectedBrandId
                }})

               }
               
               } variant="text" startIcon={<AddCircleOutlineTwoToneIcon />}>
              Add New
            </Button>
        </div>
     
        </div>
        <div style={{ width: '100%' }}>
          <DataGrid

            // table customization start
            sx={{
              '& .MuiDataGrid-columnHeaderTitle': {
                whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold",
              },
              '& .MuiDataGrid-columnHeader': {
                backgroundColor: "#D0D0D0"
              },
              '& .Mui-odd': {
                textOverflow: "inherit", fontSize: "12px", textAlign: "left"
              },

              '& .Mui-even': {
                backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"

              },

              '& .Mui-cellown': {
                paddingTop: 0, paddingBottom: 0

              },

            }}

            getCellClassName={(params) => 'Mui-cellown'}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
            autoHeight={true}
            getRowHeight={() => 'auto'}

            // table customization



            rows={sizesData}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}

            pageSizeOptions={[10, 25, 50]}

          />
        </div>

<div>
      {/*    <Button variant="outlined" onClick={handleClickOpen}>
        Open dialog
      </Button> 
    <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      > 
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Modal title
        </BootstrapDialogTitle>
        <DialogContent dividers>
        
        
          <Typography gutterBottom>
            Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus
            magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec
            ullamcorper nulla non metus auctor fringilla.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Save changes
          </Button>
        </DialogActions>
      </BootstrapDialog> */}
    </div>


    </div>

  );
}


export default ProductSizesTable;
